"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HbSpinnerProvider = exports.HB_QUIPS_FLAVOR = exports.HB_QUIPS_MISSION = exports.HbLoadingSpinner = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Css_1 = require("../Css");
const utils_1 = require("../utils");
const HbLoadingSpinner_base64_1 = __importDefault(require("./HbLoadingSpinner.base64"));
function HbLoadingSpinner({ noQuips, extraQuips = [], extraQuipsOnly, iconOnly }) {
    const ctx = (0, react_1.useContext)(HbLoadingSpinnerContext);
    const tid = (0, utils_1.useTestIds)({}, "hbSpinner");
    const quip = (0, react_1.useMemo)(() => {
        const allQuips = extraQuipsOnly && extraQuips.length !== 0 ? extraQuips : [...ctx.quips, ...extraQuips];
        // If quips are off globally but custom quips were provided, then override global
        const forceQuips = extraQuips.length !== 0 || noQuips === false;
        if ((ctx.noQuips && !forceQuips) || noQuips || allQuips.length === 0)
            return "Loading...";
        return allQuips[Math.floor(Math.random() * allQuips.length)];
    }, [ctx.noQuips, ctx.quips, extraQuips, extraQuipsOnly, noQuips]);
    return ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.fdc.jcc.aic.$, ...tid, children: [(0, jsx_runtime_1.jsx)("img", { src: HbLoadingSpinner_base64_1.default, "data-chromatic": "ignore" // Chromatic timing would snapshot this on different frames of the 24-frame gif, so ignore it
                , css: Css_1.Css.add({
                    // Image is white-on-black, so this flips it to black-on-white for our almost-always white backgrounds
                    filter: "invert(1)",
                }).$, alt: "loading", ...tid.gif }), !iconOnly && ((0, jsx_runtime_1.jsx)("div", { "data-chromatic": "ignore" // ignore spapshotting on randomized loading quips -- Mostly for consumers so their snapshots aren't constantly triggering
                , ...tid.quip, children: quip }))] }));
}
exports.HbLoadingSpinner = HbLoadingSpinner;
const dotDotDot = (str) => str.concat("...");
/** Quips for Homebound's Mission Statement. Internal. */
exports.HB_QUIPS_MISSION = [
    "Loading",
    "One Team",
    "On a Mission",
    "Executing Relentlessly",
    "Building Better",
    "In Service of Our Customers",
].map(dotDotDot);
/** Fun quips internal employees should recognize. Internal. */
exports.HB_QUIPS_FLAVOR = ["HOM is HOW", "Scaling Massively", "#LoveIt"].map(dotDotDot);
const HbLoadingSpinnerContext = react_1.default.createContext({
    quips: ["Loading..."],
    noQuips: false,
});
function HbSpinnerProvider({ quips = [], children }) {
    const state = (0, react_1.useMemo)(() => ({ quips, noQuips: quips.length === 0 }), [quips]);
    return (0, jsx_runtime_1.jsx)(HbLoadingSpinnerContext.Provider, { value: state, children: children });
}
exports.HbSpinnerProvider = HbSpinnerProvider;
